"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorLogLevel = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
var ErrorLogLevel;
(function (ErrorLogLevel) {
    ErrorLogLevel.Schema = centralized_zod_1.z.enum(["error", "warn", "info", "debug"]);
})(ErrorLogLevel || (ErrorLogLevel = {}));
exports.ErrorLogLevel = ErrorLogLevel;
